import React, { Component } from 'react'
import Modal from 'react-bootstrap/lib/Modal'
import Logo from '../../images/shoutbase-logo.svg'
import BigTag from '../big_tag'
import * as config from '../../config'
import { calculateBigTag } from '../../common/components/big_tag'

const Checkbox = ({ handleChecked }) => <input type="checkbox" onChange={handleChecked}/>

class TagRow extends Component {
    handleChecked = (id) => {
        const { pushSelectedBigTagIds, popSelectedBigTagIds, selectedBigTagIds } = this.props
        if (!selectedBigTagIds.includes(id)) {
            pushSelectedBigTagIds(id)
            return
        }

        popSelectedBigTagIds(id)
    }

    render() {
        const { bigTag, noOp, editTag, reportTag, archiveTag, i, foundTag, selectedBigTagIds, allowEdit } = this.props
        const isSelected = selectedBigTagIds.includes(bigTag.id)
        const showCheckbox = !config.isProd // TODO remove feature toggle when multi-tag actions work
        return (
            <tr className={isSelected ? "selectedRow" : ""}>

                {showCheckbox && <td className="tag-checkbox">
                    <Checkbox handleChecked={() => this.handleChecked(bigTag.id)} />
                </td>}
                <td className="tag-container">
                    <BigTag
                        key={i}
                        bigTag={bigTag}
                        editTag={false}
                        createTimeEntry={noOp}
                        showMenu={false}
                        isTagAdmin={true}
                        newTimer={noOp}
                        toggleTagReport={noOp}
                        onSelect={noOp}
                        showInfo={false}
                    />
                    <span className="tag-id">
                        ID: {foundTag.id}
                    </span>
                </td>
                <td></td>
                <td></td>
                <td></td>
                {selectedBigTagIds.length < 1 && <td>
                    {allowEdit && <button className='btn btn-default btn-edit' onClick={() => editTag(foundTag)}>EDIT</button>}
                    <button className='btn btn-default btn-report' onClick={() => reportTag(foundTag)}>REPORT</button>
                    {allowEdit && <button className='btn btn-default btn-archive' onClick={() => archiveTag(foundTag)}>
                        {foundTag.isArchived ? 'UNARCHIVE' : 'ARCHIVE'}
                    </button>}
                </td>}
            </tr>
        )
    }
}

const ActionRow = (selectedBigTagIds) => {
    const { length } = selectedBigTagIds
    const tagPlural = length > 1 ? "tags" : "tag"

    return (
        <div className="action-row">
            <span>{`${length} ${tagPlural} selected`}</span>

            <div className="">
                {selectedBigTagIds.length > 1 && <button className="btn btn-default">MERGE</button>}
                <button className="btn btn-default btn-archive">ARCHIVE</button>
            </div>
        </div>
    )
}

class TagAdminModal extends Component {
    constructor(props) {
        super(props)
        this.renderSort = this.renderSort.bind(this)
        this.changeSort = this.changeSort.bind(this)
        this.renderTag = this.renderTag.bind(this)

        this.state = {
            sortCol: "name",
            sortDir: "asc",
            selectedBigTagIds: [],
            showArchived: false,
        }
    }

    pushSelectedBigTagIds = (id) => {
        this.setState({selectedBigTagIds: [...this.state.selectedBigTagIds, id]})
    }

    popSelectedBigTagIds = (id) => {
        this.setState({selectedBigTagIds: this.state.selectedBigTagIds.filter(bigTagId => bigTagId !== id)})
    }

    renderHeader(team, isPersonal, allowEdit) {
        return (
            <div className="tag-modal-nav">
                <div className="nav-items">
                    <img src={Logo} alt="Shoutbase Logo" />
                    <span className="team-name">{isPersonal ? 'Your Tags' : team.name}</span>
                    {!isPersonal && <span className="chevron"><i className="fa fa-chevron-right"></i></span>}
                    {!isPersonal && <span>Tags</span>}
                </div>
                {allowEdit &&
                    <button className='btn btn-default add-tag-btn' onClick={this.props.createNewTag}>New Tag</button>
                }
            </div>
        )
    }

    renderTag(foundTag, i, editTag, reportTag, archiveTag) {
        const { selectedBigTagIds } = this.state
        const { allowEdit } = this.props
        const bigTag = calculateBigTag(foundTag)

        const noOp = () => {}

        return (
            <TagRow
                noOp={noOp}
                bigTag={bigTag}
                key={i}
                allowEdit={allowEdit}
                editTag={editTag}
                reportTag={reportTag}
                archiveTag={archiveTag}
                foundTag={foundTag}
                popSelectedBigTagIds={this.popSelectedBigTagIds}
                pushSelectedBigTagIds={this.pushSelectedBigTagIds}
                selectedBigTagIds={selectedBigTagIds}
                i={i}
            />
        )
    }

    renderSort(colName) {
        if (this.state.sortCol !== colName) {
            return <i className={`fa fa-chevron-down`}></i>
        }

        const upDown = this.state.sortDir === 'asc' ? 'down' : 'up'
        return <i className={`fa fa-chevron-${upDown} selected`}></i>
    }

    changeSort(colName) {
        return () => {
            const newSortDir = this.state.sortDir === 'asc' ? 'desc' : 'asc'
            this.setState({sortCol: colName, sortDir: newSortDir})
        }
    }

    render() {
        const { tags=[], allowEdit, showTagAdminModal, toggleTagAdminModal, team, editTag, createNewTag, reportTag, archiveTag, isPersonal } = this.props
        const { sortCol, sortDir, selectedBigTagIds, showArchived } = this.state
        const activeTags = tags.filter(t => !t.isArchived)
        const archivedTags = tags.filter(t => t.isArchived)
        const displayTags = showArchived ? archivedTags : activeTags
        const sortedTags = sortCol === 'name' && sortDir === 'desc' ? displayTags.slice().reverse() : displayTags

        return (
            <Modal dialogClassName="tag-admin-modal" className="modal-v2" show={showTagAdminModal} onHide={toggleTagAdminModal} animation={false}>
                <Modal.Header closeButton>
                    {this.renderHeader(team, isPersonal, allowEdit)}
                </Modal.Header>
                <Modal.Body id="modal-body" style={{height: window.innerHeight, overflowY: 'auto'}}>
                    <div className="tag-list">
                        <div className="tag-admin-tabs">
                            <button
                                className={`btn btn-default tab-btn ${!showArchived ? 'active' : ''}`}
                                onClick={() => this.setState({ showArchived: false })}
                            >
                                Active ({activeTags.length})
                            </button>
                            <button
                                className={`btn btn-default tab-btn ${showArchived ? 'active' : ''}`}
                                onClick={() => this.setState({ showArchived: true })}
                            >
                                Archived ({archivedTags.length})
                            </button>
                        </div>
                        {selectedBigTagIds.length > 0 && ActionRow(selectedBigTagIds)}
                        <table className="tag-table">
                            <thead>
                                <tr className={selectedBigTagIds.length > 0 ? "table-header-row" : ""}>
                                    <th className="sortable" onClick={this.changeSort('name')}>Tag Name {this.renderSort('name')}</th>
                                    {/* <th className="sortable" onClick={this.changeSort('hours')}>Hours {this.renderSort('hours')}</th>
                                    <th className="sortable" onClick={this.changeSort('activity')}>Activity {this.renderSort('activity')}</th>
                                    <th className="sortable" onClick={this.changeSort('members')}>Members {this.renderSort('members')}</th> */}
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {sortedTags.length > 0 && sortedTags.map( (t, i) => this.renderTag(t, i, editTag, reportTag, archiveTag))}
                                {sortedTags.length < 1 && <tr>
                                    <td className="no-tags">
                                        {showArchived
                                            ? 'No archived tags.'
                                            : <span>No tags. {allowEdit && <a className="create-tag-link" href="javascript:;" onClick={createNewTag}>Create one!</a>}</span>
                                        }
                                    </td>
                                </tr>}
                            </tbody>
                        </table>
                    </div>
                </Modal.Body>
            </Modal>
        )
    }
}

export default TagAdminModal


// WEBPACK FOOTER //
// ./src/components/modals/tag_admin.jsx